module.exports = vendor_a05bd82d9a88038c3f5e;